/**
 * Copyright (c) 2018-present, Didi, Inc.
 * All rights reserved.
 *
 * @author Cory(kuanghongrui@didichuxing.com)
 *
 * @since v2.0
 * @file The class of OmegaTracker
 */

import { ITracker } from 'com/didichuxing/tracker/ITracker';
import { ITrackerConfiguration } from 'com/didichuxing/tracker/config/ITrackerConfiguration';
import H5Tracker from 'com/didichuxing/tracker/h5/H5Tracker';
import GlobalUtil from 'com/didichuxing/tracker/plugin/utils/GlobalUtil';
export default class OmegaTracker {

    /**
     * 生成tracker对象。
     * 兼容v1.0
     * @param {ITrackerConfiguration} config
     * @returns {ITracker}
     */
    public static getTracker(config: ITrackerConfiguration): ITracker {
        if (!(config && config.appKey && GlobalUtil.isEmptyString(config.appKey))
            && (config && config.productName && GlobalUtil.isEmptyString(config.productName))) {
                Object.assign(config, {appKey: config.productName});
        }
        if (config && config.appKey && GlobalUtil.isEmptyString(config.appKey)) {
            // 避免小数点造成多层对象访问
            const appKeyVar = config.appKey.replace(/\./g, '_');
            const OMG_INSTANTIATION_NAME_VAR = `${ H5Tracker.OMG_INSTANTIATION_NAME }_${appKeyVar}__`;

            if (!(window as any)[ `${ OMG_INSTANTIATION_NAME_VAR }` ]) {
                // 如果当前没有这个对象 说明 这个APPKEY的SDK实例没有被初始化 ，可以直接初始化并且返回实例。
                const h5Tracker: ITracker = new H5Tracker(config);
                h5Tracker.execute();
                (window as any)[ `${ OMG_INSTANTIATION_NAME_VAR }` ] = h5Tracker;
                h5Tracker.getTracker = this.getTracker;
                return h5Tracker;
            } else {
                if ((window as any)[ `${ OMG_INSTANTIATION_NAME_VAR }` ].getContext().version
                    === H5Tracker.OMG_VERSION) {
                    // 版本相同直接返回之前的实例
                    return (window as any)[ `${ OMG_INSTANTIATION_NAME_VAR }` ];
                } else {
                    // 版本不同做提示 并返回之前的实例
                    console.warn('[Omega]相同appKey(' + config.appKey + ')实例化多个版本SDK,请检查！当前版本：' +
                        (window as any)[ `${ OMG_INSTANTIATION_NAME_VAR }` ].getContext().version +
                        '新实例化版本：' + H5Tracker.OMG_VERSION);
                    return (window as any)[ `${ OMG_INSTANTIATION_NAME_VAR }` ];
                }
            }
        } else {
            throw new Error('[Omega]初始化必须带有appKey 参数');
        }

    }
}
